export default __webpack_public_path__ + "static/media/Icon_home.c98e7cbc.svg";